import { Module } from "plugins/_application";
import VideoSliderClass from "../utils/_video-slider";

var $ = jQuery;

export default class VideoSlider extends Module {

	ready(app) {

        new VideoSliderClass();

    }
}